const NON_EDITABLE_INPUT_TYPES = ["button", "submit", "reset", "checkbox", "radio", "file", "image", "range", "color"];

// True when the user is actively editing text in this element: a text-like
// input, a textarea, or contenteditable. Deliberately excludes non-editable
// input types (button, checkbox, radio, …) — a focused checkbox or button is
// not something a user is "typing into."
function isEditableElement(element) {
	if (!element) return false;
	if (element.isContentEditable) return true;
	if (element.tagName === "TEXTAREA") return true;
	if (element.tagName === "INPUT") return !NON_EDITABLE_INPUT_TYPES.includes(element.type);
	return false;
}

export { isEditableElement };
